import axios from 'axios';

const api = axios.create({
  baseURL: process.env.VUE_APP_API_URL,
  headers: {
    'Content-Type': 'application/json' // Set common headers here
  }
});

// Request interceptor
api.interceptors.request.use(
  (config) => {
    // Add auth token or any other headers if needed
    const token = localStorage.getItem('authToken');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    // Handle request errors
    return Promise.reject(error);
  }
);

// Response interceptor
api.interceptors.response.use(
  (response) => {
    // Any status code within the 2xx range will trigger this function
    return response;
  },
  (error) => {

    // Check if the error response status is 422
    if (error.response && error.response.status === 422) {
      // Handle 422 errors as non-rejected responses
      console.log(error);
      return Promise.resolve(error.response);
    }
    return Promise.reject(error);
  }
);


export default api;
